import { Box, Stack, TextField, Button, Tooltip, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../Styles/Colors';
import { DataGrid } from '@mui/x-data-grid';
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../Components/Common Components/CommonComponents';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import { CheckAccessFunc } from '../../Components/CommonFunctions/CommonFunctions';

const HistopathologySpecimenMaster = ({}) => {
    const [state, setState] = useState({
        specimen_master_data: [],
        specimen_type: '',
        specimen_code: '',
        specimen_prefix: '',
        is_active: true,
        edit_id: null,
        is_loader: false,
        // deleted_ids: [],
        selected_ids: [],
        is_inactive: false,
        is_delete: false,
        checkbox_list: [],
        page: 0,
        pageSize: 10,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
    });

    useEffect(() => {
        getTherapyMasterList()
    }, [])

    const Access = CheckAccessFunc("Histopathology", "Masters", "Histopathology  Masters", "Specimen Master", "SubTab");

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const getTherapyMasterList = () => {
        try {
            updateState({ is_loader: true })
            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_SPECIMEN)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || []
                        updateState({
                            specimen_master_data: Data?.map((element, index) => ({ ...element, sno: index + 1 })),
                            is_loader: false
                        })
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            updateState({ is_loader: false })
            errorMessage(e.message)
        }
    }

    const textBox = (label, name, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    inputProps={{ maxLength: name === "specimen_prefix" ? 7 : 200 }}
                    value={state[name] || ""}
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => {
                        if (name === "specimen_prefix" && e.target.value) {
                            updateState({ [name]: e.target.value?.toUpperCase() })
                        } else {
                            updateState({ [name]: e.target.value })
                        }
                    }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const tableView = () => {

        const grpInactive = () => {
            updateState({ is_inactive: true })
        }

        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText
                        fromStore={true}
                        isDelete={state?.selected_ids?.length > 0}
                        DeleteBtnText={"Inactive"}
                        removeData={grpInactive.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            const selectedIDs = new Set(id);
            const selectedRows = state?.specimen_master_data?.filter((row) => selectedIDs.has(row.sno));
            const FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            updateState({ checkbox_list: id, selected_ids: FinalData })
        }

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.1,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.sno ? row?.sno : '-'}</Box>)
            },
            {
                field: 'specimen_code', headerName: 'Specimen Type Code', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.specimen_code ? row?.specimen_code : '-'}</Box>)

            },
            {
                field: 'specimen_prefix', headerName: 'Prefix', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.specimen_prefix ? row?.specimen_prefix : '-'}</Box>)
            },
            {
                field: 'specimen_type', headerName: 'Specimen Type', flex: 0.5,
                renderCell: ({ row }) => (row.specimen_type ? row.specimen_type?.length > 70 ?
                    <Tooltip placement="top" title={row.specimen_type}><Typography fontSize={'0.9vw'}>{row.specimen_type?.slice(0, 70) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{row.specimen_type}</Typography> : '-')

            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.is_active ? "Active" : 'InActive'}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: ({ row }) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={state?.selected_ids?.length > 0 || !Access?.editAccess}
                                onClick={() => {
                                    updateState({
                                        specimen_code: row.specimen_code || '',
                                        specimen_type: row.specimen_type || '',
                                        specimen_prefix: row.specimen_prefix || "",
                                        is_active: row.is_active,
                                        edit_id: row.id
                                    })
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={Access?.editAccess}
                    selectionModel={state.checkbox_list}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    isRowSelectable={(params) => params.row.is_active}
                    rows={state.specimen_master_data}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => { updateState({ pageSize: newPageSize }) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={state.is_loader}
                />
            </Box>
        )
    }

    const clearFunction = () => {
        updateState({
            specimen_code: '',
            specimen_type: '',
            specimen_prefix: "",
            is_active: true,
            edit_id: null,
            is_loader: false,
            selected_ids: [],
            is_inactive: false,
            checkbox_list: [],
            is_delete: false,
        })
    }

    const addTherapyDetails = () => {
        try {
            const data = {
                'specimen_type': state.specimen_type,
                'specimen_prefix': state.specimen_prefix,
                'is_active': state.is_active,
            }
            if (state?.edit_id) {
                data["id"] = state?.edit_id
            }
            RestAPIService[state.edit_id ? "create" : "create"](data, Serviceurls.HISTOPATHOLOGY_SPECIMEN)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        clearFunction()
                        getTherapyMasterList()
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    // const deleteTherapyMaster = () => {
    //     try {
    //         RestAPIService.delete(`${Serviceurls.HISTOPATHOLOGY_SPECIMEN}?id=${state.deleted_ids || []}`, {})
    //             .then((response) => {
    //                 if (response.data.status === 'success') {
    //                     successMessage(response.data.message)
    //                     getTherapyMasterList()
    //                     clearFunction()
    //                 }
    //             }).catch(e => {
    //                 errorMessage(e?.response?.data?.message || e?.message)
    //             })
    //     } catch (e) {
    //         errorMessage(e.message)
    //     }
    // }

    // const deleteClsPop = () => {
    //     updateState({
    //         is_delete: false,
    //         checkbox_list: [],
    //         deleted_ids: [],
    //     })
    // }

    const inactiveTherapyMaster = () => {
        try {
            RestAPIService.delete(`${Serviceurls.HISTOPATHOLOGY_SPECIMEN}?ids=${state.selected_ids || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getTherapyMasterList()
                        clearFunction()
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const inactiveClsPop = () => {
        updateState({
            is_inactive: false,
            checkbox_list: [],
            deleted_ids: [],
            selected_ids: []
        })
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {textBox("Specimen Type Code", 'specimen_code', '15vw', true)}
                        {textBox("Prefix", 'specimen_prefix', '15vw')}
                        {textBox("Specimen Type *", 'specimen_type', '30vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={
                            <Checkbox checked={state.is_active}
                                onChange={(e) => { updateState({ is_active: e.target.checked }) }}
                                size='small' disabled={!state.edit_id} />}
                            label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={!state.specimen_type?.trim() || !state.specimen_prefix?.trim() || !Access?.editAccess} onClick={() => { addTherapyDetails() }}>{state.edit_id ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
            {state.is_inactive &&
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to InActive this specimen ?`}
                    deleteAlertPopupClose={inactiveClsPop.bind(this)}
                    removeData={inactiveTherapyMaster.bind(this)}
                    ButtonText={"Inactive"}
                />}
        </Box>
    )
}
export default HistopathologySpecimenMaster